// #region Imports
import { Produto } from './Produto';
// #endregion

// #region Builders
export function buildProdutoPartial() { return new Produto({}); }
// #endregion

// #region Adaptadores armazenamento
export function fromStorage(raw) { return Produto.fromJSON(raw); }
export function toStorage(produto) { return produto instanceof Produto ? produto.toJSON() : produto; }
// #endregion

// #region Estatísticas
export function computeStats(list) {
  const total_produtos = list.length;
  const produtos_baixo_estoque = list.filter(p => p.estoque_atual <= p.estoque_min).length;
  const valor_total_estoque = list.reduce(
    (acc, p) => acc + (Number(p.preco_venda) || 0) * (Number(p.estoque_atual) || 0),
    0,
  );
  return { total_produtos, produtos_baixo_estoque, valor_total_estoque };
}
// #endregion

// #region Helpers UI
export function formatCurrencyBRL(v) { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0); }
export function formatDate(d) {
  if (!d) return '';
  try { return new Intl.DateTimeFormat('pt-BR').format(new Date(d)); } catch { return d; }
}
// #endregion
